////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const pricesManagerByArticle = {
	getPriceArticles: (
		filters = {},
		queryParams = {
			page: '0',
			size: '250',
			action: 'byItem',
			sort: 'itemDistributor.item.family.label',
			nameDir: 'asc',
			sort_2: 'itemDistributor.item.brand.label',
			nameDir_2: 'asc',
			sort_3: 'itemDistributor.item.label',
			nameDir_3: 'asc',
		}
	) => ({
		type: ActionsTypes.GET_PRICES_ARTICLE,
		payload: {
			filters,
			queryParams,
		}, //sort_2: 'itemDistributor.item.family.label', nameDir_2: 'asc'
	}),
	getPriceArticlesSuccess: (data) => ({
		type: ActionsTypes.GET_PRICES_ARTICLE_SUCCESS,
		payload: {
			data,
		},
	}),
	getPriceArticlesFailure: (error) => ({
		type: ActionsTypes.GET_PRICES_ARTICLE_FAILURE,
		payload: {
			error,
		},
	}),
}

export default pricesManagerByArticle
